import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productvariant-columnchart',
  templateUrl: './productvariant-columnchart.component.html',
  styleUrls: ['./productvariant-columnchart.component.scss']
})
export class ProductvariantColumnchartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
